<template>
  <v-container fluid pa-0 fill-height>
    <v-row class="fill-height ma-0">
      <v-col cols="12" md="6" class="align-center justify-center d-flex">
        <v-row justify="center">
          <v-card class="pa-10 pb-8" max-width="420" :elevation="24">
            <Logo
              :url="getCouncilImage"
              alt="Logo Benfeitores"
              height="65"
              width="185"
            />
            <h4 class="mt-12">Login</h4>
            <p class="mt-2">Parece que seu perfil está associado a mais de uma empresa. Selecione a empresa que deseja fazer login:</p>
              <v-row>              
                <v-container fluid class="pa-0 mb-10">
                  <v-col>
                    <v-select
                      v-model="selectedLoggedEntity"
                      :items="entities"
                      label="Empresa"
                      name="entities"
                      item-text="entityViewModel.name"
                      outlined
                      hide-details
                      :disabled="loading"
                      return-object
                      class="mb-10"
                    ></v-select>
                  </v-col>
                </v-container>              
              </v-row>
              <v-col cols="12">
                <v-btn
                 :loading="loading"
                 rounded
                 depressed
                 x-large
                 block
                 color="primary"
                 @click="GotToDashBoard()"                 
                 :disabled="!selectedLoggedEntity"
                 >Entrar</v-btn
                >
              </v-col>
        </v-card>
       </v-row>
      </v-col>
      <v-col md="6" class="login-image justify-center align-center">
        <v-layout column class="p-relative" fill-height z-1>
          <v-layout align-end text-center>
          </v-layout>
        </v-layout>
      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Logo from "@/components/Logo";
import Routes from "@/router/names.js";
import AuthService from "@/scripts/services/auth.service";

export default {
  name: "ChooseEntity",
  inject: ["theme"],
    components: {
    Logo
  },
  data: () => ({
    authService: new AuthService(),
    entities: [],
    loading: false,
    routes: Routes,
    selectedLoggedEntity: null,
    permissions: []
  }),
  mounted() {
    if(this.$route.params.entities){
      this.entities = this.$route.params.entities;
    } else {
      this.authService
        .getUserEntities()
        .then(this.getEntitiesCallback)
        .catch(this.getEntitiesCatch);
    }
  },
   computed: {
    ...mapGetters("userModule", ["loggedEntityId"]),
    ...mapGetters(["getCouncilImage"]),
    
  },
  methods: {
    ...mapActions("userModule", ["setPermissions", "setLoggedEntityId"]),
    getEntitiesCallback(result) {
      this.entities = result;
    },
    getEntitiesCatch() {
      
    },
    GotToDashBoard() {
      this.setLoggedEntityId(this.selectedLoggedEntity.entityViewModel.id);

      let selectedLoggedEntity = this.entities.find(e => e.id === this.selectedLoggedEntity.id);

      this.permissions.push(selectedLoggedEntity);
      this.setPermissions(this.permissions);
      this.$router.push({ name: Routes.app.Dashboard });
    }
  } 
};
</script>

<style lang="scss" scoped>

.copyright {
  color: #6c7293;
  font-size: 12px;
  text-align: center;
  padding: 32px;
}

/* Conteudo da direita */
.login-image {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(112, 77, 250);
  background: -moz-linear-gradient(
    297deg,
    rgba(112, 77, 250, 1) 0%,
    rgba(93, 206, 242, 1) 100%
  );
  background: -webkit-linear-gradient(
    297deg,
    rgba(112, 77, 250, 1) 0%,
    rgba(93, 206, 242, 1) 100%
  );
  background: linear-gradient(
    297deg,
    rgba(112, 77, 250, 1) 0%,
    rgba(93, 206, 242, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#704dfa",endColorstr="#5dcef2",GradientType=1);
}

.login-image:after {
  content: "";
  display: block;
  background-image: url(https://images.pexels.com/photos/1684916/pexels-photo-1684916.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260);
  background-size: cover;
  background-position: top right;
  position: absolute;
  opacity: 0.2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  filter: grayscale(1);
}
</style>